const comHeader = (() => {
  if (document.querySelector("header.header") !== null) {



    let header = document.querySelector('header.header');

    let tl = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: 'header.header',
        endTrigger: 'body',
        start: "0% 0%",
        end: "100% -1000%",
        pin: true,
        pinSpacing: false,
        // markers: true,
      },
    })

    // let target = document.querySelector('body');
    // let observer = new ResizeObserver((entries) => {
    //   entries.forEach((entry) => {
    //     tl.scrollTrigger.refresh()
    //   });
    // });
    // observer.observe(target);



  }
})()
export default comHeader;